/** Сброс блокировки скролла (попапы) и прокрутка документа в начало. */
export function resetDocumentScrollToTop() {
  if (typeof window === "undefined") return;

  document.body.classList.remove("exit-intent-lead-open");
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  document.body.style.overflow = "";
  document.documentElement.style.overflow = "";

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const root = document.getElementById("root");
  if (root) root.scrollTop = 0;
}
